document.querySelectorAll('.tabs_container').forEach((section) => {

  const tabHeads = section.querySelectorAll('.heading_tab_text');
  const tabContents = section.querySelectorAll('.tab_content');

  tabHeads.forEach((head) => {
    head.addEventListener('click', () => {
      const tabId = head.dataset.tab;
      /* Remove Active */
      tabHeads.forEach((item) => {
        item.classList.remove('is--active');
      });

      tabContents.forEach((item) => {
        item.classList.remove('is--active');
      });

      /* Add Active */
      head.classList.add('is--active');
      const activeTab = section.querySelector(`#${tabId}`);
      if (activeTab) {
        activeTab.classList.add('is--active');
      }
    });
  });
});

//white space removal
 document.addEventListener("DOMContentLoaded", function() {
    var containers = document.querySelectorAll(".ingredients-container");

    containers.forEach(function(container) {
      var childDivs = container.querySelectorAll("div");
      var isEmpty = true;

      childDivs.forEach(function(childDiv) {
        if (childDiv.textContent.trim() !== "") {
          isEmpty = false;
        }
      });

      if (isEmpty) {
        container.style.display = "none";
      }
    });
  });

 
/** custom product review slider */
document.addEventListener('DOMContentLoaded', function () {

  const sliders = document.querySelectorAll('.regime-with-product-switcher .tab_content');

  sliders.forEach((slider) => {

    /* Prevent Duplicate Init */
    if (slider.dataset.sliderInit) return;
    slider.dataset.sliderInit = 'true';

    /* Create Wrapper */
    const wrapper = document.createElement('div');
    wrapper.classList.add('review-slider-wrapper');

    slider.parentNode.insertBefore(wrapper, slider);
    wrapper.appendChild(slider);

    /* Remove any pre-existing arrows inside this wrapper */
    wrapper.querySelectorAll('.review-slider-arrow').forEach(el => el.remove());

    /* Arrow Scroll Amount */
    function getScrollAmount() {
      const item = slider.querySelector('.review-item');
      return item ? item.offsetWidth + 20 : 300;
    }

    /* Get slide count for this slider */
    const slideCount = slider.querySelectorAll('.review-item').length;

    /* Create Prev Arrow */
    const prevBtn = document.createElement('button');
    prevBtn.className = 'review-slider-arrow review-slider-prev';
    prevBtn.setAttribute('aria-label', 'Previous');
    prevBtn.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill="none">
        <path d="M7.80317 14.7212L0.353386 7.27145M0.353386 7.80358L7.80317 0.353793" stroke="white"/>
      </svg>
    `;

    /* Create Next Arrow */
    const nextBtn = document.createElement('button');
    nextBtn.className = 'review-slider-arrow review-slider-next';
    nextBtn.setAttribute('aria-label', 'Next');
    nextBtn.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill="none">
        <path d="M0.353565 14.7212L7.80335 7.27145M7.80335 7.80358L0.353565 0.353793" stroke="white"/>
      </svg>
    `;

    if (slideCount > 2) {
      wrapper.appendChild(prevBtn);
      wrapper.appendChild(nextBtn);
    }

    /* Show/hide arrows based on active tab */
    function toggleArrowsVisibility() {
      const isActive = slider.classList.contains('is--active');
      prevBtn.style.display = isActive ? '' : 'none';
      nextBtn.style.display = isActive ? '' : 'none';
    }

    /* Add/remove disabled class at start / end */
    function updateArrowState() {
      const maxScroll = slider.scrollWidth - slider.clientWidth;
      const atStart = slider.scrollLeft <= 1;
      const atEnd = slider.scrollLeft >= maxScroll - 1;

      prevBtn.classList.toggle('disabled', atStart);
      nextBtn.classList.toggle('disabled', atEnd);

      prevBtn.setAttribute('aria-disabled', atStart);
      nextBtn.setAttribute('aria-disabled', atEnd);
    }

    /* Arrow Click */
    prevBtn.addEventListener('click', () => {
      if (prevBtn.classList.contains('disabled')) return;
      slider.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', () => {
      if (nextBtn.classList.contains('disabled')) return;
      slider.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });

    /* Update on scroll (covers arrows, swipe, trackpad) and resize */
    slider.addEventListener('scroll', updateArrowState, { passive: true });
    window.addEventListener('resize', updateArrowState);

    /* Expose a refresh hook for the tab-switch handler below */
    slider._refreshArrows = function () {
      toggleArrowsVisibility();
      updateArrowState();
    };

    /* Initial state */
    slider._refreshArrows();
  });

  /* When tab switches, show/hide arrows and recalc disabled state */
  document.querySelectorAll('.regime-with-product-switcher [data-tab]').forEach(tabBtn => {
    tabBtn.addEventListener('click', () => {
      // setTimeout lets the tab-switching script toggle .is--active first,
      // and lets the newly shown slider get real dimensions
      setTimeout(() => {
        document.querySelectorAll('.regime-with-product-switcher .tab_content').forEach(slider => {
          if (slider._refreshArrows) slider._refreshArrows();
        });
      }, 50);
    });
  });

  /* Recalc once everything (images etc.) has loaded */
  window.addEventListener('load', () => {
    document.querySelectorAll('.regime-with-product-switcher .tab_content').forEach(slider => {
      if (slider._refreshArrows) slider._refreshArrows();
    });
  });

});
/** end custom product review slider */


/** inside the actives section */
document.querySelectorAll('.actives-tab-switcher:not([data-tab-init])').forEach(function (container) {
  container.setAttribute('data-tab-init', 'true');

  const contents = Array.from(container.querySelectorAll('.tab_contents .tab_content'));
  const headings = Array.from(container.querySelectorAll('.switching_tab_heading .heading_tab_text'));

  if (contents.length === 0) return;

  if (!contents.some(el => el.classList.contains('is--active'))) {
    contents[0].classList.add('is--active');
    if (headings.length > 0) headings[0].classList.add('is--active');
  }

  let isTransitioning = false;

  function goToTab(index) {
    if (isTransitioning) return;
    isTransitioning = true;

    contents.forEach(function (el) { el.classList.remove('is--active'); });
    contents[index].classList.add('is--active');

    if (headings.length > 0) {
      headings.forEach(function (el) { el.classList.remove('is--active'); });
      if (headings[index]) {
        headings[index].classList.add('is--active');
        headings[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }

    setTimeout(function () { isTransitioning = false; }, 600);
  }

  function getActiveIndex() {
    const index = contents.findIndex(function (el) { return el.classList.contains('is--active'); });
    return index === -1 ? 0 : index;
  }

  const prevBtn = container.querySelector('.tabs-arrow--prev');
  const nextBtn = container.querySelector('.tabs-arrow--next');

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      goToTab((getActiveIndex() - 1 + contents.length) % contents.length);
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      goToTab((getActiveIndex() + 1) % contents.length);
    });
  }

  const swipeArea = container.querySelector('.tab-switch-cs');
  if (!swipeArea) return;

  let touchStartX = 0;
  let touchStartY = 0;
  let isSwiping = false;
  const SWIPE_THRESHOLD = 50;
  const AXIS_LOCK = 30;

  swipeArea.addEventListener('touchstart', function (e) {
    touchStartX = e.changedTouches[0].clientX;
    touchStartY = e.changedTouches[0].clientY;
    isSwiping = true;
  }, { passive: true });

  swipeArea.addEventListener('touchmove', function (e) {
    if (!isSwiping) return;
    const deltaY = Math.abs(e.changedTouches[0].clientY - touchStartY);
    const deltaX = Math.abs(e.changedTouches[0].clientX - touchStartX);
    if (deltaY > deltaX) isSwiping = false;
  }, { passive: true });

  swipeArea.addEventListener('touchend', function (e) {
    if (!isSwiping) return;
    isSwiping = false;

    const deltaX = e.changedTouches[0].clientX - touchStartX;
    const deltaY = e.changedTouches[0].clientY - touchStartY;

    if (Math.abs(deltaY) > AXIS_LOCK) return;
    if (Math.abs(deltaX) < SWIPE_THRESHOLD) return;

    const current = getActiveIndex();

    if (deltaX < 0) {
      goToTab((current + 1) % contents.length);
    } else {
      goToTab((current - 1 + contents.length) % contents.length);
    }
  }, { passive: true });

});
/** end inside the actives section */